import {Button as ButtonUI} from "@ya.praktikum/react-developer-burger-ui-components";
import {TButton} from "../utils/types";

export const Button: TButton = ButtonUI;
